import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-wood-dark text-white p-4 md:p-6 shadow-2xl">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm md:text-base leading-relaxed">
              Web sitemizde deneyiminizi geliştirmek için çerezler kullanılmaktadır.{' '}
              <Link to="/kvkk" className="underline hover:text-beige transition-colors">
                KVKK
              </Link>
              {' '}ve{' '}
              <Link to="/cerez" className="underline hover:text-beige transition-colors">
                Çerez Politikamızı
              </Link>
              {' '}kabul ediyor musunuz?
            </p>
          </div>
          <button
            onClick={handleAccept}
            className="w-full md:w-auto px-6 py-3 bg-white hover:bg-beige text-wood-dark rounded-full font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            Kabul Et
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
